export default __webpack_public_path__ + "static/media/Logo_Icon.f89421af.png";